import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Skeleton from '../skeleton/WaitingPeriodSkeleton';
import CustomClientError from '../../../../../errorhandling/CustomClientError';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from '../../../../../../api/axios';

const DisabilityWatingPeriodTemplate = (planInfo) => {
  const [WaitingPeriodData, setWaitingPeriodData] = useState();
  const [skeletonLoader, setSkeletonLoader] = useState(true);
  const [serverError, setServerError] = useState(false);
  const fetchContent = async (MasterId, benefitCode) => {
    try {
      //const isDataLoaded = loadedWaitingPeriodData.filter( data => data.benefitCode === benefitCode && data.masterID === MasterId ).length;
      //if ( isDataLoaded ) {
      //const loadData = loadedWaitingPeriodData.filter( data => data.benefitCode === benefitCode && data.masterID === MasterId );
      //setWaitingPeriodData( loadData[ 0 ].waitingPeriodDetails );
      //setSkeletonLoader( false );
      //} else {
      const waitingPeriodDetails = await axiosInstance.get(
        APIEndpoints.getCoveredServiceWaitingPeriod() +
          'MasterID/' +
          MasterId +
          '/benefitcode/' +
          benefitCode,
      );
      setWaitingPeriodData(
        waitingPeriodDetails?.data?.Response?.DisabilityWaitingPeriod,
      );
      //setLoadedWaitingPeriodData(  [ ...loadedWaitingPeriodData, {
      //'benefitCode': benefitCode,
      //'masterID': MasterId,
      //'waitingPeriodDetails': waitingPeriodDetails?.data?.Response?.DisabilityWaitingPeriod
      //} ] );
      setSkeletonLoader(false);
    } catch (e) {
      setServerError(true);
    }
  };

  useEffect(() => {
    if (
      planInfo.coveredservicesDetails.ServiceType === planInfo.currentActiveTab
    ) {
      fetchContent(
        planInfo?.PlanInfo?.MasterId,
        planInfo?.coveredservicesDetails?.BenefitText,
      );
    }
  }, [
    planInfo?.coveredservicesDetails?.BenefitText,
    planInfo.currentActiveTab,
  ]);
  const { t } = useTranslation();
  const getDuration = (scale, unit) => {
    switch (unit) {
      case 'A':
        return `${scale} Weeks`;
      case 'C':
        return `${scale} Calender Days`;
      case 'W':
        return `${scale} Working Days`;
      default:
        return `${scale}`;
    }
  };

  return (
    <>
      {serverError ? (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Server request failed. Please contact support team."
          CustomClasses={'error-box-container'}
        />
      ) : (
        <>
          {skeletonLoader ? (
            <Skeleton />
          ) : (
            <div className="back-Injuries-card mb-4">
              <div className="benefit">
                <Card>
                  <div className="benefit-card">
                    <span className="min-benefit">
                      {'Minimum Benefit'}
                      <p className="benefit-card-pay">{`$${WaitingPeriodData.MinBenefitAmt}`}</p>
                    </span>
                    <span className="max-benefit">
                      {'Maximum Benefit'}
                      <p className="benefit-card-pay">{`$${WaitingPeriodData.MaxBenefitAmt}`}</p>
                    </span>
                  </div>
                  <div className="benefit-card">
                    <span className="benefit-span-left">
                      {'Benefit Allowed Period'}
                    </span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.BenefitAllowedPeriod,
                        WaitingPeriodData.BenefitAllowedPeriodUnits,
                      )}
                    </span>
                  </div>
                  <div className="benefit-card border-0">
                    <span className="benefit-span-left">
                      {'Benefit Allowed Max Length'}
                    </span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.BenefitAllowedMaxLength,
                        WaitingPeriodData.BenefitAllowedMaxLengthUnits,
                      )}
                    </span>
                  </div>
                </Card>
              </div>
              <div className="waiting-period">
                <Card>
                  <div className="waiting-period-header">
                    <h5 className="waiting-period-text">
                      {t('member.pages.coverages.waiting_time')}
                    </h5>
                  </div>
                  <div className="waiting-period-card">
                    <span className="benefit-span-left">{'Accidental'}</span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.AccidentWaitingPeriodDays,
                        WaitingPeriodData.AccidentPeriodType,
                      )}
                    </span>
                  </div>
                  <div className="waiting-period-card">
                    <span className="benefit-span-left">{'Illness'}</span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.IllnessWaitingPeriodDays,
                        WaitingPeriodData.IllnessPeriodType,
                      )}
                    </span>
                  </div>
                  <div className="waiting-period-card">
                    <span className="benefit-span-left">{'Hospital'}</span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.HospitalWaitingPeriodDays,
                        WaitingPeriodData.HospitalPeriodType,
                      )}
                    </span>
                  </div>
                  <div className="waiting-period-card border-0">
                    <span className="benefit-span-left">{'Others'}</span>
                    <span className="benefit-span-right">
                      {getDuration(
                        WaitingPeriodData.OtherWaitingPeriodDays,
                        WaitingPeriodData.OtherPeriodType,
                      )}
                    </span>
                  </div>
                </Card>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default DisabilityWatingPeriodTemplate;
